// extracted by mini-css-extract-plugin
export default {"loading":"buttons_loading__u3L+I"};